import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApContentModule } from '@ap/content';
import { MijnLoginTemplateModule } from '@ap/mijn-template';
import { ApNotificationComponent } from '@ap/notification';
import { ApScrollService } from '@ap/scroll';

import { DigicodeHerstelModule } from '../../klant/digicode-herstel/digicode-herstel.module';

import { DigicodeHerstelWrapperComponent } from './digicode-herstel.wrapper.component';

/**
 * @ngdoc module
 * @name DigicodeHerstelWrapperModule
 */
@NgModule({
    declarations: [DigicodeHerstelWrapperComponent],
    imports: [ApContentModule, ApNotificationComponent, CommonModule, DigicodeHerstelModule, MijnLoginTemplateModule],
    exports: [DigicodeHerstelWrapperComponent],
    providers: [ApScrollService]
})
export class DigicodeHerstelWrapperModule {}
